import createErrors from '../createErrors';
import { type Page } from './constants';

export type Component = 'OrderSearchPage';

/**
 * Errors related to the Order Details page
 */
export const Errors = createErrors<Page, Component>('OrderSearch')({
    OrderSearchPage: {
        ValidateOrderFailed: {
            severity: 'MEDIUM',
            message: 'Failed to validate order search form',
        },
    },
});
